export default "__VITE_ASSET__C83CM7oM__"